import React, { Component } from 'react'
import { Layout, Menu, Icon } from 'antd'
import { withRouter, NavLink } from 'react-router-dom'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'

import './main.css'
import logoSafecash from '../../assets/safecash-logo.png'
import logoSafecashIcon from '../../assets/safecash-logo-icon.png'

const cookies = new Cookies()

const { Header, Sider, Content } = Layout

class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: false,
      setMargin: 200,
      setLogo: logoSafecash,
      username: cookies.get('usernameSASSafecash'),
    }
  }

    handleLogout = () => {
      cookies.remove('tokenSASSafecash', { path: '/' })
      cookies.remove('usernameSASSafecash', { path: '/' })
      window.location.href = '/'
    }

    toggle = () => {
      this.setState({
        collapsed: !this.state.collapsed,
        setMargin: !this.state.setMargin,
        setLogo: !this.state.setLogo,
      })
    }

    render() {
      const logo = this.state.setLogo ? logoSafecash : logoSafecashIcon
      const marginLayout = this.state.setMargin ? 200 : 80
      const { location } = this.props

      return (
        <Layout>
          <Sider
            trigger={null}
            collapsible
            collapsed={this.state.collapsed}
            style={{
              overflow: 'auto', height: '100vh', position: 'fixed', left: 0, backgroundColor: '#133f7d',
            }}
          >
            <div className="field-logo">
              <div className="logo">
                <img src={logo} alt="" />
              </div>
            </div>

            <div>
              <Menu
                theme="dark"
                mode="inline"
                defaultSelectedKeys={['/']}
                selectedKeys={[location.pathname]}
                style={{ backgroundColor: '#133f7d' }}
              >
                <Menu.Item key="/dashboard">
                  <NavLink to="/dashboard" className="nav-text">
                    <Icon type="home" />
                    <span>Dashboard</span>
                  </NavLink>
                </Menu.Item>

                <Menu.Item key="/orders">
                  <NavLink to="/orders" className="nav-text">
                    <Icon type="shopping-cart" />
                    <span>Orders</span>
                  </NavLink>
                </Menu.Item>

                <Menu.Item key="/users">
                  <NavLink to="/users" className="nav-text">
                    <Icon type="usergroup-add" />
                    <span>Users</span>
                  </NavLink>
                </Menu.Item>
              </Menu>
            </div>


          </Sider>

          <Layout style={{ marginLeft: marginLayout, transition: 'all .2s' }}>
            <Header style={{ background: '#fff', padding: 0 }}>
              <Icon
                className="trigger"
                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
              />

              <div className="logout">
                Hallo, {this.state.username}
                <Icon
                  type="logout"
                  onClick={this.handleLogout}
                />
              </div>

            </Header>
            <Content style={{ padding: 24, minHeight: 280 }}>
              {this.props.children}
            </Content>
          </Layout>
        </Layout>
      )
    }
}

Main.defaultProps = {
  location: null,
  children: <div />,
}

Main.propTypes = {
  location: PropTypes.object,
  children: PropTypes.element,
}

export default withRouter(Main)



// WEBPACK FOOTER //
// src/components/main/index.js